/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import SubscriptionCenterService from 'cio/services/subscription-center';
import FeaturesService from 'ember-feature-flags/services/features';

interface SubscriptionCenterIsDisabledBannerArgs {
  type?: string;
}

export default class SubscriptionCenterIsDisabledBanner extends Component<SubscriptionCenterIsDisabledBannerArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;
  @service features!: FeaturesService;

  get type() {
    return this.args.type ?? 'Campaign';
  }

  get bannerAction() {
    return 'Go to subscription center';
  }

  get bannerTitle() {
    return `The ${this.type.toLowerCase()} will send to everyone until topics are enabled in the subscription center`;
  }

  fetchMissingTopics = task({ drop: true }, async () => {
    await this.subscriptionCenter.fetchMissingTopicsTask.perform();
  });
}
